<template>
    <div class="container">
        <div class="card">
                <base-table-spinner v-if="!invoice"></base-table-spinner>
                
                <InvoicePreview v-else :invoice="invoice" />
        </div>
    </div>

</template>

<script>
import InvoicePreview from '../../components/InvoicePreview.vue';
import request from '@/utils/request'

export default {
    components: {
        InvoicePreview
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data(){
        return {
            invoice: null,
        }
    },
    mounted(){
        this.getInvoiceDetails();    
    },
    methods: {
        async getInvoiceDetails() {
            try {
                const {data} = await request.get('/users/invoice-details/'+ this.id);
                this.invoice = data.invoice;
            } catch(e) {
                console.log('error', e);
                this.$store.commit('setError', 'Unable to find Invoice');
            }
        }
    }
}
</script>